'use strict';

export class Tabs {
	constructor(component_key) {
		this.id = component_key;

		this.component = yalwa.v.components[component_key];
		this.data = {};
		this.send_data = {};
		this.api = '';
		this.action = '';
		this.$root = jQuery(`.js-${this.id}`);
		this.$elements = this.$root.find(`.js-${this.id}_elements`);
		this.$items = jQuery(`.js-${this.id}_item`);
		this.$sections = jQuery(`.js-${this.id}_section`);
		this.$current_item =this.$items.filter('.active');
		this.$current_section =this.$sections.filter('.active');
	}
	
	init() {
		const zero_point = this.$elements.position().left;
		const current_item_left = this.$current_item.position().left;
		const scroll_to = current_item_left - zero_point;
		this.$elements.scrollLeft(scroll_to);
		this.add_events();
	}
	
	// Abstract method: should be implemented by subclasses
	add_events() {
		throw new Error("Method 'add_events()' must be implemented in the subclass.");
	}
}

